import React from 'react'
import { useI18n } from '../i18n'

export default function SafetyLockNotice({ lock, locked }) {
  const { t } = useI18n()
  if (!lock?.locked && !locked) return null
  return (
    <div role="status" style={{ padding: '12px', border: '1px solid #bd6a64', borderRadius: '8px', margin: '8px 0', overflowWrap: 'anywhere' }}>
      <strong>{t('safetyReview.noticeTitle')}</strong>
      <p>{t('safetyReview.reason', { reason: lock?.reason || t('safetyReview.reasonUnknown') })}</p>
      {lock?.locked_at ? <p>{t('safetyReview.since', { time: lock.locked_at })}</p> : null}
      <p>{t('safetyReview.noticeExplanation')}</p>
    </div>
  )
}
